module.exports = __webpack_public_path__ + "img/laboratorio5_4-3_682.7dbfd1ea.jpg";